import React from "react";
import {AOperation} from "../../../models/operations/AOperation";
import {operationsWithIconUrls} from "../../../models/utils/EOperationType";
import {autoFormatDate, DATE_FORMAT_WITH_TIME} from "../../../services/UtilsService";
import DisplayLatLong from "../DisplayLatLong";
import DisplayOperationAccordingToTypeService from "../../../services/DisplayOperationAccordingToTypeService";
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    /**
     * Operation to display.
     */
    operation: AOperation
}

/**
 * Displays the attributes common to all operations.
 * Calls upon a service to display the other attributes according to the type of operation.
 * @author Alizée Grand
 * @version 1.1
 * @creation 31/05/2022
 * @last_update 11/07/2022
 **/
class DisplayBasicOperation extends React.Component<Props> {

    render() {

        /**
        * Retrieves from the props the function to access the translation.
        **/
        const getTranslation = this.props.t;

        return (

            <div>
                <span><b>{getTranslation("display.operation.type")}</b> : {getTranslation(operationsWithIconUrls[this.props.operation.type].translateKeyName)}</span>
                <br/>
                <span><b>{getTranslation("display.operation.code")}</b> : {this.props.operation.idUser}</span>
                <br/>
                <span><b>{getTranslation("display.operation.date")}</b> : {autoFormatDate(this.props.operation.date, DATE_FORMAT_WITH_TIME)}</span>
                <br/>
                <span><b>{getTranslation("display.operation.localisation")}</b> : <br/><DisplayLatLong geolocation={this.props.operation.geolocation!}/></span>
                <br/>
                {
                    // Displays the attributes specific to the type of operation
                    DisplayOperationAccordingToTypeService.generatesOperationDisplayElementsAccordingToThisType(this.props.operation)
                }
                <span><b>{getTranslation("display.operation.comment")}</b> : {this.props.operation.commentary || "-"}</span>
            </div>

        );

    };

}

export default withTranslation()(DisplayBasicOperation);
